import { UnfoldLessVerticalIcon } from './UnfoldLessVerticalIcon';

/**
 * author: Austin Andrews
 * id E4DFDADF-60F8-4E90-A501-38381F4346A0
 * name unfold-less-vertical
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unfold-less-vertical.svg
 * tags
 */
export const CollapseVerticalIcon = UnfoldLessVerticalIcon;
export default CollapseVerticalIcon